import $ from 'jquery'
import './main.scss'

$(document).on('click', '[data-action=comment-edit]', function (e) {
  e.preventDefault()

  const $comment = $(this).closest('.comment')
  $comment.addClass('comment--editing')
  $comment
    .find('.comment__actions--options--show')
    .removeClass('comment__actions--options--show')
  $comment.find('trix-editor').focus()
})

$(document).on('click', '[data-action=comment-reply]', async function (e) {
  e.preventDefault()

  let $self = $(this)
  let $comment = $self.closest('.comment')
  if (!$comment.hasClass('comment--allow-reply')) {
    const idx = $comment.index() - 1
    $comment = $comment.siblings(`:gt(${idx}).comment--allow-reply:first`)
  }

  $comment.addClass('comment--replying')
  const $replyForm = $comment.next('.comment__reply-form')
  $replyForm.find('trix-editor').focus()

  const $editor = $replyForm.find('trix-editor')[0].editor
  let $mentionCommenter = true
  const $sgid = $self.data('sgid')
  $editor
    .getDocument()
    .getAttachments()
    .map(function (attachment) {
      if (attachment.attributes?.values?.sgid === $sgid)
        $mentionCommenter = false
    })

  if ($mentionCommenter && $sgid) {
    let TrixAttachment = (await getTrix()).Attachment
    const $attachment = new TrixAttachment({
      sgid: $sgid,
      content: $self.data('mention-content'),
    })
    $editor.insertAttachment($attachment)
    $editor.insertString(' ')
  }
})

$(document).on('click', '[data-action=comment-editor-cancel]', function (e) {
  e.preventDefault()
  $(this).closest('.comment').removeClass('comment--editing')
})

$(document).on('click', '[data-action=comment-reply-cancel]', function (e) {
  e.preventDefault()
  $(this)
    .closest('.comment__reply-form')
    .prev('.comment')
    .removeClass('comment--replying')
})

$(function () {
  $('.comment__body a').attr('target', '_blank')

  $('.comment__body').each(function (_i) {
    // This needs a delay for some reason, otherwise height is always 0.
    setTimeout(() => {
      if ($(this).height() > 300) {
        $(this).parents('.comment').addClass('comment--truncatable')
      }
    }, 100)
  })
})

$(document).on('click', '.comment__untruncate', function (e) {
  $(this).parents('.comment').addClass('comment--untruncated')
})

$(document).on('click', '.comment__truncate', function (e) {
  $(this).parents('.comment').removeClass('comment--untruncated')
})

$(document).on('click', '.comment__actions--btn', function (e) {
  e.stopPropagation()

  $(this)
    .closest('.comment__actions--dropdown')
    .find('.comment__actions--options')
    .toggleClass('comment__actions--options--show')
})

$(document).on('click', function () {
  $('.comment__actions--options--show').removeClass(
    'comment__actions--options--show'
  )
})

async function getTrix() {
  return import('trix')
}
